import { Pipe, PipeTransform } from '@angular/core';

import { tipoClassificacaoCadastros } from '../tipo-classificacao-cadastro';

@Pipe({
    name: 'tipoClassificacaoCadastro'
})
export class TipoClassificacaoCadastroPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = tipoClassificacaoCadastros.findIndex(cadastro => cadastro.id === value);
        if (index > -1) {
            return tipoClassificacaoCadastros[index].nome;
        }
        return '';
    }
}
